import { reducerWithInitialState } from "typescript-fsa-reducers";
import { combineReducers } from "redux";

import { EntitiesMap, EntityMap } from "../../entities";
import { Project } from "../entities";
import { loadProviders, authSucceeded, createSupport, Provider } from "../actions";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../../companies/actions";

export interface Provider {
  name: string;
  available: boolean;
  canPost: boolean;
}

interface SupportStatus {
  supportable: boolean;
  supported: boolean;
}

export interface ProjectSupportsMainState {
  projects: { [key: string]: SupportStatus };
  providers: Provider[];
  isLoadingProviders: boolean;
  isLoadedProviders: boolean;
}

export interface ProjectSupportsState {
  supports: ProjectSupportsMainState;
  entities: EntitiesMap; // Not using entities yet
}

function initProjects(projectEntities: EntityMap<Project>) {
  const projects: { [key: string]: SupportStatus } = {};
  Object.entries(projectEntities).forEach(([id, project]) => {
    projects[id] = { supportable: project!.can_support || false, supported: project!.supported || false };
  });
  return projects;
}

const projectSupportsReducer = reducerWithInitialState<ProjectSupportsMainState>({
  projects: {},
  providers: [],
  isLoadingProviders: false,
  isLoadedProviders: false,
})
  .case(loadProviders.started, state => {
    return { ...state, isLoadingProviders: true };
  })
  .case(loadProviders.done, (state, action) => {
    const providers = action.result;
    return { ...state, providers, isLoadingProviders: false, isLoadedProviders: true };
  })
  .case(loadProviders.failed, state => {
    return { ...state, isLoadingProviders: false };
  })
  .case(authSucceeded, (state, providerName) => {
    const provider = state.providers.find(p => p.name === providerName)!;
    const newProvider: Provider = { ...provider, canPost: true };
    const index = state.providers.findIndex(p => p.name === providerName);
    const providers = [
      ...state.providers.slice(0, index),
      newProvider,
      ...state.providers.slice(index + 1, state.providers.length),
    ];
    return { ...state, providers };
  })
  .case(createSupport.done, (state, action) => {
    const { projectId } = action.params;
    const projects = { ...state.projects, [projectId]: { supportable: false, supported: true } };
    return { ...state, projects };
  })
  .cases([bootstrapCompanyProjects], (state, action) => {
    const projects = initProjects(action.entities.projects);
    return { ...state, projects };
  })
  .cases([loadCompanyProjects.done], (state, action) => {
    const projects = initProjects(action.result.entities.projects);
    return { ...state, projects };
  });

const entitiesReducer = reducerWithInitialState<EntitiesMap>({});

export default combineReducers({
  supports: projectSupportsReducer,
  entities: entitiesReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/project_supports/reducers/index.ts